/* eslint-disable import/no-unresolved */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormProvider } from 'react-hook-form';

import IconMC from '../../../components/IconMC';
import InputMC from '../../../components/InputMC';
import DropdownMC from '../../../components/DropdownMC';
import { filterOption as countryFilterOption } from '../../../../services/countryService';

const PaymentLinksCustomerData = ({
  formMethods,
  countryOptions,
  documentTypeOptions
}) => {
  const { t } = useTranslation('Inbox');

  const filterCountryOptions = (searchTerm) => {
    if (!searchTerm) return countryOptions;

    return countryOptions.filter((option) => {
      const value = option.value || option.id || option.code;
      const data = option;
      return countryFilterOption({ value, data }, searchTerm);
    });
  };

  return (
    <FormProvider {...formMethods}>
      <div className="tw-flex tw-flex-col tw-gap-4 tw-wrapper">
        <div className="tw-flex tw-flex-col tw-gap-2">
          <span className="tw-font-semibold tw-text-gray-950 tw-text-sm">{t('sendPaymentLinks.customerData')}</span>
          <div className="tw-flex tw-items-center tw-justify-start tw-gap-1 tw-p-4 tw-rounded-lg tw-bg-yellow-50 tw-border tw-border-yellow-100">
            <IconMC name="alert-circle-outline" className="tw-text-yellow-500 tw-rotate-180" size="4xl" />
            <span className="tw-text-xs tw-text-yellow-600 tw-font-medium">
              {t('sendPaymentLinks.customerDataWarning')}
            </span>
          </div>
        </div>

        <InputMC
          id="email"
          name="email"
          label={t('sendPaymentLinks.email')}
          type="email"
          useFloatingLabel
        />

        <InputMC
          id="first_name"
          name="first_name"
          label={t('sendPaymentLinks.firstName')}
          useFloatingLabel
          className="tw-w-full"
        />

        <InputMC
          id="last_name"
          name="last_name"
          label={t('sendPaymentLinks.lastName')}
          useFloatingLabel
          className="tw-w-full"
        />

        <div className="tw-grid tw-grid-cols-5 tw-gap-2 tw-w-full">
          <DropdownMC
            id="country_id"
            name="country_id"
            label={t('sendPaymentLinks.country')}
            options={countryOptions}
            defaultValue={formMethods.getValues('country_id')}
            filterOption={filterCountryOptions}
            className="tw-col-span-2"
            useFloatingLabel
            search
          />
          <InputMC
            id="phone"
            name="phone"
            label={t('sendPaymentLinks.phoneNumber')}
            useFloatingLabel
            containerClass="tw-col-span-3"
            type="number"
          />
        </div>

        <div className="tw-grid tw-grid-cols-5 tw-gap-2">
          <DropdownMC
            id="id_type"
            name="id_type"
            label={t('sendPaymentLinks.documentType')}
            options={documentTypeOptions}
            defaultValue={formMethods.getValues('id_type')}
            className="tw-col-span-2"
            useFloatingLabel
          />
          <InputMC
            id="id_number"
            name="id_number"
            label={t('sendPaymentLinks.identification')}
            useFloatingLabel
            containerClass="tw-col-span-3"
          />
        </div>
      </div>
    </FormProvider>
  );
};

export default PaymentLinksCustomerData;
